import { useState } from 'react'
import styled from 'styled-components'
import ErrorableInputWrapper from '../components/molecules/common/ErrorableInputWrapper'
import LabeledInput from '../components/molecules/LabeledInput'
import MainButton from '../components/atoms/MainButton'
import GenderSelector from '../components/molecules/auth/GenderSelector'
import DefaultLayout from '../components/molecules/common/DefaultLayout'
import { useBottomsheet } from '../hooks/useBottomSheet'
import DateOfBirthBottomSheet from '../components/molecules/auth/DateOfBirthBottomSheet'
import LanguageDisorderBottomSheet from '../components/molecules/auth/LanguageDisorderBottomSheet'
import { registerChild } from '../api/auth'
import { useNavigate } from 'react-router-dom'
import Text from '../components/atoms/Text'
import { logEvent } from '../utils/eventLogger'

const Wrapper = styled.form`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px; 
`
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 20px;
  gap: 4px;
`
const ButtonWrapper = styled.div`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 600px; // Wrapper 최대 폭과 맞춤
  padding: 0 20px;   // 좌우 여유
`

const ChildRegister = ({ next }) => {
  const isSignupFlow = next.startsWith('/signup');
  const navigate = useNavigate();

  const [childInfo, setChildInfo] = useState({
    name: '',
    birth: '',
    gender: null,
    disorder: '',
  })

  const [nameError, setNameError] = useState('')

  const handleChange = (e) => {
    setChildInfo((prev) => ({ ...prev, name: e.target.value }));

    if (nameError) setNameError('');
  };

  const handleSelectBirth = (date) => {
    setChildInfo(prev => ({ ...prev, birth: date }));
  };

  const handleSelectDisorder = (disorderType) => {
    setChildInfo(prev => ({ ...prev, disorder: disorderType }));
  };

  const handleBlur = () => {
    if (!childInfo.name.trim()) setNameError('이름을 입력해주세요.');
    else if (childInfo.name.length < 2) setNameError('이름은 최소 2자 이상입니다.');
    else setNameError('');
  };

  const handleSubmit = async(e) => {
    e?.preventDefault();
    if (!isBtnValid) return;

    try {
      const data = {
      name: childInfo.name,
      birthday: childInfo.birth,
      gender: childInfo.gender,
      language_disorder_type: childInfo.disorder
    };
      // console.log(childInfo)
      await registerChild(data)
      
      // 로그 기록
      logEvent("children_register_save")
      
      if (isSignupFlow) {
      // 아이등록 성공 후 childId를 서버로부터 받아야할까? -> accessTocken 발급
      sessionStorage.setItem('childRegistered', 'true');
     }
      navigate(next);
    } catch (err) {
      console.error(err);
      // console.log('아이등록 실패')
    }
  };

  const isBtnValid =
    childInfo.name?.trim().length >= 2 &&
    childInfo.birth &&
    childInfo.gender;

  const bottomSheet = useBottomsheet(); // 바텀시트 훅 호출

  // 바텀시트 컴포넌트 object literal
  const bottomSheetComponents = {
    date: () => <DateOfBirthBottomSheet $isOpen={bottomSheet.isOpen} onClose={bottomSheet.close} onChangeBirth={handleSelectBirth}/>,
    disability: () => <LanguageDisorderBottomSheet $isOpen={bottomSheet.isOpen} onClose={bottomSheet.close} onChangeDisorder={handleSelectDisorder}/>
  }
    
  const CurrentBottomSheet = bottomSheet.sheetType ? bottomSheetComponents[bottomSheet.sheetType] : null;

  return (
    <DefaultLayout>
      <TextWrapper>
        <Text variant="headline2" weight="medium">아이 정보를 입력해주세요.</Text>
      </TextWrapper>
      <Wrapper onSubmit={handleSubmit}>
        <ErrorableInputWrapper $error={nameError} message={nameError}>
          <LabeledInput
            name="childName"
            autoComplete="off"
            label="아이 이름"
            placeholder="아이 이름 입력"
            value={childInfo.name}
            required={true}
            onChange={handleChange}
            onBlur={handleBlur}
            $error={nameError}/>
        </ErrorableInputWrapper>
        <ErrorableInputWrapper>
          <LabeledInput
            name="childBirthday"
            label="아이 생년월일"
            placeholder="아이 생년월일 선택"
            value={childInfo.birth}
            required={true}
            readOnly
            onClick={() => bottomSheet.open("date")}/>
        </ErrorableInputWrapper>
        <GenderSelector
          selected={childInfo.gender}
          onSelect={(value) => setChildInfo(prev => ({ ...prev, gender: value }))}/>
        <ErrorableInputWrapper>
          <LabeledInput
            name="disorderType"
            label="언어장애 유형"
            placeholder="아이의 언어장애 유형 선택"
            value={childInfo.disorder}
            readOnly
            onClick={() => bottomSheet.open("disability")}/>
        </ErrorableInputWrapper>
        <ButtonWrapper>
          <MainButton
            $variant="primary"
            title="완료"
            disabled={!isBtnValid}
            type="submit"/>
        </ButtonWrapper>
      </Wrapper>
      {CurrentBottomSheet && <CurrentBottomSheet/>}
    </DefaultLayout>
  )
}

export default ChildRegister
